import TestComponent from 'common/components/TestComponent';
import ChangePassword from 'features/auth/ChangePassword';
import ChangeUserInfo from 'features/auth/ChangeUserInfo';
import CheckPasswordCode from 'features/auth/CheckPasswordCode';
import Favorites from 'features/auth/Favorites';
import ForgotPassword from 'features/auth/ForgotPassword';
import Login from 'features/auth/Login';
import Profile from 'features/auth/Profile';
import Register from 'features/auth/Register';
import SavedSearches from 'features/auth/SavedSearches';
import VerificationSent from 'features/auth/VerificationSent';
import VerifyEmailCode from 'features/auth/VerifyEmailCode';
import Home from 'features/home/Home';
import Legal from 'features/info/Legal';
import CreateListing from 'features/list/CreateListing';
import ListingInfo from 'features/list/ListingInfo';
import Sell from 'features/list/Sell';
import ItemDetail from 'features/search/ItemDetail';
import Search from 'features/search/Search';
import SearchResults from 'features/search/SearchResults';
import { Route, Routes } from 'react-router-dom';

import { appRoutes } from './app-routes';
import AuthGuard from './AuthGuard';
import ErrorPage from './ErrorPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path={appRoutes.home} element={<Home />} />
      <Route element={<Search />}>
        <Route path={appRoutes.search} element={<SearchResults />} />
      </Route>
      <Route path={`${appRoutes.itemDetail}/:id/:backLabel`} element={<ItemDetail />} />
      <Route path={appRoutes.sell} element={<Sell />} />

      <Route path={appRoutes.register} element={<Register />} />
      <Route path={appRoutes.login} element={<Login />} />
      <Route path={appRoutes.resetPassword} element={<ForgotPassword />} />
      <Route path={`${appRoutes.resetPassword}/:email`} element={<ForgotPassword />} />
      <Route path={`${appRoutes.changePassword}/:id/:code`} element={<ChangePassword />} />
      <Route path={`${appRoutes.checkPasswordCode}/:email`} element={<CheckPasswordCode />} />
      <Route path={`${appRoutes.verifyEmail}/:email`} element={<VerificationSent />} />
      <Route path={appRoutes.checkPasswordCode} element={<CheckPasswordCode />} />
      <Route path={`${appRoutes.verifyEmailCode}/:email/:code`} element={<VerifyEmailCode />} />
      <Route path={`${appRoutes.listingInfo}/:id`} element={<ListingInfo />} />

      <Route path={appRoutes.legal} element={<Legal />} />
      <Route path={appRoutes.errorPage} element={<ErrorPage />} />
      <Route path={appRoutes.test} element={<TestComponent />} />

      {/* auth routes */}
      <Route path={appRoutes.favorites} element={<AuthGuard>{<Favorites />}</AuthGuard>} />
      <Route path={appRoutes.changeUserInfo} element={<AuthGuard>{<ChangeUserInfo />}</AuthGuard>} />
      <Route path={appRoutes.savedSearches} element={<AuthGuard>{<SavedSearches />}</AuthGuard>} />
      <Route path={appRoutes.createListing} element={<AuthGuard>{<CreateListing />}</AuthGuard>} />
      <Route path={appRoutes.profile} element={<AuthGuard>{<Profile />}</AuthGuard>} />
      <Route path={appRoutes.changeUserInfo} element={<AuthGuard>{<ChangeUserInfo />}</AuthGuard>} />
    </Routes>
  );
};

export default AppRoutes;
